// Onboarding progress bar (SPEC §3, "front-loaded"): one continuous bar, track 6px radius 3, accent fill with glow,
// width transition 700ms. Values per step are OB_PROGRESS in lines.ts (arrive -> answered).
//   <ProgressBar pct={answered ? 34 : 8} />            on a plain background
//   <ProgressBar pct={93} overScene />                 over a picture (lighter track)
import type { JSX } from 'preact';

export interface ProgressBarProps { pct: number; overScene?: boolean; label?: string; style?: JSX.CSSProperties }

export function ProgressBar({ pct, overScene, label = 'Setup progress', style }: ProgressBarProps) {
  const v = Math.max(0, Math.min(100, Math.round(pct)));
  return (
    <div
      role="progressbar" aria-label={label} aria-valuemin={0} aria-valuemax={100} aria-valuenow={v}
      style={{ flex: 1, height: 6, borderRadius: 3, background: overScene ? 'rgba(255,255,255,0.22)' : 'rgba(255,255,255,0.16)', overflow: 'hidden', ...style }}
    >
      <div style={{
        width: `${v}%`, height: 6, borderRadius: 3, background: 'var(--acc)', boxShadow: '0 0 10px var(--acc-glow-strong, var(--acc))',
        transition: 'width 700ms cubic-bezier(.2,.9,.3,1)',
      }} />
    </div>
  );
}
